var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEarthJourney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 458,
    viewBox: "0 0 467 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.974 7.49279C303.045 -22.3699 429.131 52.8055 459.597 175.402C490.062 297.997 413.369 421.589 288.298 451.451C163.228 481.314 37.1408 406.138 6.67557 283.543C-23.7897 160.947 52.9033 37.3555 177.974 7.49279Z",
    fill: "url(#paint0_radial_734_1106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_734_1106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.4055 319.802) rotate(-31.2056) scale(419.764 381.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827187,
    stopColor: "#3A1C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ED574"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEarthJourney);
export default __webpack_public_path__ + "static/media/img-earth-journey.85b0862b2f5f59d57cf67d8fcb18d992.svg";
export { ForwardRef as ReactComponent };